"use client";

import React, { useEffect, useState } from "react";
import { StyledBar } from "./stickyMobileCta.styles";
import { trackEvent } from '@/lib/track';

interface IStickyMobileCtaProps {
  buttonText: string;
  href: string;
  microcopy?: string;
  eventName?: string;
  showAfterPx?: number;
}

export const StickyMobileCta = ({
  buttonText,
  href,
  microcopy,
  eventName,
  showAfterPx = 600,
}: IStickyMobileCtaProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > showAfterPx);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [showAfterPx]);

  const handleClick = () => {
    if (eventName) trackEvent(eventName);
  };

  return (
    <StyledBar className={visible ? "visible" : ""} aria-hidden={!visible}>
      <div className="inner">
        {microcopy && <span className="microcopy">{microcopy}</span>}
        <a className="cta" href={href} onClick={handleClick} tabIndex={visible ? 0 : -1}>
          {buttonText}
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </StyledBar>
  );
};
